import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

const LCard = () => {
    return (
        <Card style={{ width: 300, padding: '16px' }}>
            <CardMedia
                component="img"
                alt="Logo"
                height="200"
                image='/images/lender/marg.jpeg'
                style={{ objectFit: 'contain' }}
            />
            <CardContent style={{ marginTop: '16px', fontFamily: 'Plus Jakarta Sans' }}>
                <Typography variant="h6" component="h2" gutterBottom style={{ fontFamily: 'Plus Jakarta Sans' }}>
                    Marg Techno Projects Ltd
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p" style={{ fontFamily: 'Plus Jakarta Sans' }}>
                    RBI Reg No. 01.00071 <br />
                    GST NO. 24AABCM6013F1Z0 <br />
                    CIN NO. L69590GJ1993PLC019764
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p" style={{ marginTop: '16px', fontFamily: 'Plus Jakarta Sans' }}>
                    <Link href="https://margtechno.com/" target="_blank" rel="noopener" style={{ fontFamily: 'Plus Jakarta Sans' }}>
                        Visit Website
                    </Link>
                </Typography>
            </CardContent>
        </Card>
    );
};

export default LCard;
